export * from './lib/ui-dialog-alert.module';
// components
export * from './lib/ui-dialog-alert/ui-dialog-alert.component';